// // I got a Gif file that consist of name folder "images", and a Gif.js file. And in "images", theres 1-31.jpg.
// //  I want Gif.js to display all the images in "images", and a download button to download them using html2canvas, all the images arrange in a single column
// //  all share the same width 700px, and this is the code :

// import { useRef } from "react";
// import html2canvas from "html2canvas";

// function Gif() {
//     const containerRef = useRef(null);

//     const handleDownload = async () => {
//         if (!containerRef.current) return;

//         const canvas = await html2canvas(containerRef.current, {
//             useCORS: true,
//             scale: 1, // higher quality
//         });

//         const link = document.createElement("a");
//         link.download = "Gif.png";
//         link.href = canvas.toDataURL("image/png");
//         link.click();
//     };

//     const images = Array.from({ length: 31 }, (_, i) => `/images/${i + 1}.jpg`);

//     return (
//         <div style={{ textAlign: "center", padding: "20px" }}>
//             <button
//                 onClick={handleDownload}
//                 style={{
//                     padding: "10px 20px",
//                     backgroundColor: "#007bff",
//                     color: "white",
//                     border: "none",
//                     borderRadius: "8px",
//                     cursor: "pointer",
//                     marginBottom: "20px",
//                 }}
//             >
//                 Download Long Image
//             </button>

//             <div ref={containerRef} style={{ display: "flex", flexDirection: "column", alignItems: "center", width: 1000, backgroundColor: '#333333' }}>
//                 {images.map((src, index) => (
//                     <img
//                         key={index}
//                         src={src}
//                         style={{ width: "100%", marginBottom: "5px" }}
//                     />
//                 ))}
//             </div>
//         </div>
//     );
// }

// export default Gif;


// I got a Gif file that consist of name folder "images", and a Gif.js file. And in "images", theres 1-31.jpg.
//  I want Gif.js to display all the images in "images", and a download button to download them using html2canvas, all the images arrange in a single column
//  all share the same width 700px, and this is the code :

// import { useRef, useState, useEffect } from "react";
// import ScreenRecorder from "../../config/ScreenRecorder";

// function Gif(props) {
//     const [currentIndex, setCurrentIndex] = useState(0);

//     // Array of image paths
//     const images = Array.from({ length: 31 }, (_, i) => `/images/${i + 1}.jpg`);
//     useEffect(()=>{
//         props.hidetopbar(true)
//     },[])
//     useEffect(() => {

//         // Set interval to update image every 1.5 seconds
//         const interval = setInterval(() => {
//             setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
//         }, 3000); // 1500ms = 1.5s

//         return () => clearInterval(interval); // Cleanup on unmount
//     }, [images.length]);

//     return (
//         <div style={{ textAlign: "center", padding: "20px", backgroundColor: "black", minHeight:'100vh', maxHeight:'100vh',overflow:'hidden', placeContent:'center' }}>
//             <div
//                 style={{
//                     width: 1400,
//                     height: "100%",
//                     margin: "0 auto",
//                     display: "flex",
//                     justifyContent: "center",
//                 }}
//             >
//                 <img
//                     key={currentIndex}
//                     src={images[currentIndex]}
//                     alt={`Slide ${currentIndex + 1}`}
//                     style={{
//                         width: "100%",
//                         height:'80vh',
//                         objectFit: "contain",
//                         borderRadius: "8px",
//                     }}
//                 />
//             </div>
//             {/* <p style={{ color: "#fff", marginTop: "10px" }}>
//                 {currentIndex + 1} / {images.length}
//             </p> */}
//                   <ScreenRecorder />
//         </div>
//     );
// }

// export default Gif;


// import React, { useRef, useState, useEffect } from "react";

// const Gif = (props) => {

//     useEffect(() => {
//         props.hidetopbar(true)
//     }, [])
//     const canvasRef = useRef(null);
//     const mediaRecorderRef = useRef(null);
//     const chunksRef = useRef([]);
//     const [recording, setRecording] = useState(false);

//     const images = Array.from({ length: 31 }, (_, i) => `/images/${i + 1}.jpg`);
//     const durationPerImage = 1500; // 1.5 seconds per image
//     const canvasWidth = 1280 * 1.5; // width of video
//     const canvasHeight = 720 * 1.5; // height of video

//     // Draw image fully (fit portrait & landscape without cropping)
//     const drawImageFit = (src) => {
//         const canvas = canvasRef.current;
//         const ctx = canvas.getContext("2d");
//         const img = new Image();
//         img.src = src;
//         img.onload = () => {
//             const cw = canvas.width;
//             const ch = canvas.height;
//             const iw = img.width;
//             const ih = img.height;

//             // Fill background (letterbox)
//             ctx.fillStyle = "#000";
//             ctx.fillRect(0, 0, cw, ch);

//             // Scale image to fit completely
//             const scale = Math.min(cw / iw, ch / ih);
//             const sw = iw * scale;
//             const sh = ih * scale;

//             // Center the image
//             const x = (cw - sw) / 2;
//             const y = (ch - sh) / 2;

//             ctx.drawImage(img, x, y, sw, sh);
//         };
//     };

//     const startSlideshow = async () => {
//         const canvas = canvasRef.current;
//         const stream = canvas.captureStream(30); // 30 FPS
//         const recorder = new MediaRecorder(stream, { mimeType: "video/webm" });

//         chunksRef.current = [];
//         recorder.ondataavailable = (e) => chunksRef.current.push(e.data);
//         recorder.onstop = () => {
//             const blob = new Blob(chunksRef.current, { type: "video/webm" });
//             const url = URL.createObjectURL(blob);
//             const a = document.createElement("a");
//             a.href = url;
//             a.download = "slideshow.webm";
//             a.click();
//         };

//         recorder.start();
//         setRecording(true);

//         // Loop through images
//         for (let i = 0; i < images.length; i++) {
//             drawImageFit(images[i]);
//             await new Promise((res) => setTimeout(res, durationPerImage));
//         }

//         recorder.stop();
//         setRecording(false);
//     };

//     return (
//         <div style={{ textAlign: "center", padding: 20 }}>
//             <button
//                 onClick={startSlideshow}
//                 disabled={recording}
//                 style={{
//                     padding: "10px 20px",
//                     backgroundColor: recording ? "gray" : "#007bff",
//                     color: "white",
//                     border: "none",
//                     borderRadius: "8px",
//                     cursor: recording ? "default" : "pointer",
//                 }}
//             >
//                 {recording ? "Recording..." : "🎥 Start Slideshow Recording"}
//             </button>

//             <canvas
//                 ref={canvasRef}
//                 width={canvasWidth}
//                 height={canvasHeight}
//                 style={{
//                     background: "#000",
//                     marginTop: 20,
//                     width: "840px", // just for screen preview (scaled down)
//                     borderRadius: 12,
//                 }}
//             />
//         </div>
//     );
// };

// export default Gif;







import React, { useRef, useState, useEffect } from "react";

const Gif = (props) => {
    const [scriptLoaded, setScriptLoaded] = useState(false);
    const canvasRef = useRef(null);
    const [recording, setRecording] = useState(false);
    const [error, setError] = useState(null);

    // 31 images, assuming files are named 1.jpg to 31.jpg
    const images = Array.from({ length: 3 }, (_, i) => `/images/${i}.jpg`);
    const durationPerImage = 50; // 10ms per image (0.31s total)
    const canvasWidth = 1280; // HD width
    const canvasHeight = 720; // HD height

    useEffect(() => {
        props.hidetopbar(true);
        // Dynamically load gifshot from CDN
        const script = document.createElement("script");
        script.src = "https://cdn.jsdelivr.net/npm/gifshot@0.4.5/dist/gifshot.min.js";
        script.async = true;
        script.onload = () => {
            console.log("gifshot loaded successfully");
            setScriptLoaded(true);
        };
        script.onerror = () => {
            console.error("Failed to load gifshot from CDN");
            setError("Failed to load GIF library. Please check your network.");
        };
        document.body.appendChild(script);
        return () => {
            document.body.removeChild(script);
        };
    }, []);

    // Draw image fully (fit portrait & landscape without cropping)
    const drawImageFit = (src) => {
        const canvas = canvasRef.current;
        const ctx = canvas.getContext("2d");
        const img = new Image();
        img.src = src;
        return new Promise((resolve, reject) => {
            img.onload = () => {
                const cw = canvas.width; // 1280
                const ch = canvas.height; // 720
                const iw = img.width;
                const ih = img.height;
                const isPortrait = ih > iw;
                const aspectRatio = iw / ih;

                // Clear canvas with black background
                ctx.fillStyle = "#000";
                ctx.fillRect(0, 0, cw, ch);

                // Scale to fit canvas, preserving aspect ratio
                const scale = Math.min(cw / iw, ch / ih);
                const scaledWidth = iw * scale;
                const scaledHeight = ih * scale;

                // Center the image
                const x = (cw - scaledWidth) / 2;
                const y = (ch - scaledHeight) / 2;

                ctx.drawImage(img, x, y, scaledWidth, scaledHeight);
                console.log(
                    `Image ${src} drawn (width: ${iw}, height: ${ih}, ` +
                    `scaled: ${scaledWidth.toFixed(2)}x${scaledHeight.toFixed(2)}, ` +
                    `portrait: ${isPortrait}, aspect: ${aspectRatio.toFixed(2)})`
                );
                resolve(canvas.toDataURL("image/png")); // Return canvas frame
            };
            img.onerror = () => {
                console.error(`Failed to load image: ${src}`);
                reject(new Error(`Failed to load image: ${src}`));
            };
        });
    };


    const startSlideshow = async () => {
        if (!scriptLoaded || !window.gifshot) {
            setError("gifshot is not loaded. Please try again.");
            console.error("gifshot not available");
            return;
        }

        setRecording(true);
        setError(null);

        try {
            // Preload images and capture canvas frames
            const frames = [];
            for (let i = 0; i < images.length; i++) {
                const frame = await drawImageFit(images[i]);
                frames.push(frame); // Store canvas data URL
                await new Promise((resolve) => setTimeout(resolve, durationPerImage));
            }

            // Create GIF using gifshot with canvas frames
            window.gifshot.createGIF(
                {
                    images: frames, // Use canvas frames instead of raw images
                    gifWidth: canvasWidth,
                    gifHeight: canvasHeight,
                    interval: durationPerImage / 1000, // 0.01s per frame
                    numWorkers: 2,
                    quality: 10,
                },
                (obj) => {
                    if (!obj.error) {
                        console.log("GIF rendering finished");
                        const url = obj.image;
                        const a = document.createElement("a");
                        a.href = url;
                        a.download = "slideshow.gif";
                        a.click();
                        URL.revokeObjectURL(url);
                        setRecording(false);
                    } else {
                        console.error("GIF creation failed:", obj.errorMsg);
                        setError(`Failed to create GIF: ${obj.errorMsg}`);
                        setRecording(false);
                    }
                }
            );
        } catch (err) {
            console.error("GIF creation failed:", err);
            setError(`Failed to create GIF: ${err.message}`);
            setRecording(false);
        }
    };

    return (
        <div style={{ textAlign: "center", padding: 20, display:'flex', flexDirection:'column' }}>
            {error && (
                <div style={{ color: "red", marginBottom: 10 }}>{error}</div>
            )}
            <button
                onClick={startSlideshow}
                disabled={recording || !scriptLoaded}
                style={{
                    padding: "10px 20px",
                    backgroundColor: recording || !scriptLoaded ? "gray" : "#007bff",
                    color: "white",
                    border: "none",
                    borderRadius: "8px",
                    cursor: recording || !scriptLoaded ? "default" : "pointer",
                }}
            >
                {recording
                    ? "Recording..."
                    : scriptLoaded
                    ? "🎥 Start Slideshow Recording"
                    : "Loading..."}
            </button>

            <canvas
                ref={canvasRef}
                width={canvasWidth}
                height={canvasHeight}
                style={{
                    background: "#000",
                    marginTop: 20,
                    width: "840px", // Scaled for preview
                    borderRadius: 12,
                }}
            />
        </div>
    );
};

export default Gif;